import styled, { css } from 'styled-components';

export const FiltersButton = styled.button`
  display: flex;
  color: inherit;
  white-space: nowrap;
  scroll-snap-align: start;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;

  ${({ theme }) => css`
    background-color: ${theme.colors.transparent};
    color: ${theme.colors.navyBlueSub1};
    font-size: ${theme.fontSizes.p2};
    font-weight: ${theme.fontWeights.bold};
    gap: ${theme.spacing(0.5)};
    padding: ${theme.spacing(1, 2)};
  `}
`;
